// Image buffers are recreated independently. Insertion anchors alone cannot
// preserve the order when radar labels survive a frame refresh.
export function enforceObservationLayerOrder(map) {
    const layers = map.getStyle()?.layers || [];
    const radarIndex = layers.findIndex(layer => /^ws-radar-(?:\d+|coverage)$/.test(layer.id));
    if (radarIndex < 0) return;
    const radarId = layers[radarIndex].id;
    for (let i = radarIndex + 1; i < layers.length; i++) {
        if (/^ws-sat-\d+(?:-\d+)?$/.test(layers[i].id)) map.moveLayer(layers[i].id, radarId);
    }
}
